<template>
  <div class="w-full fixed pin-l pin-b z-10 text-right pr-10 bg-tr6">
    <div
      :class="
        show
          ? 'btn-drawer clearfix active text-center cursor-pointer'
          : 'btn-drawer clearfix text-center cursor-pointer'
      "
      @click.stop="$emit('update:show', !show)"
    >
      <span class="btn-drawer-font float-left">{{ active.name }} 附近 </span>
      <i class="btns-arrow float-left inline-block" />
    </div>
    <transition name="drawer">
      <div v-if="show" :class="isIphoneX ? 'drawer x-css' : 'drawer'">
        <i
          class="iconfont icon-close inline-block cursor-pointer absolute pin-t pin-r z-11"
          aria-hidden="true"
          @click.stop="$emit('update:show', false)"
        />
        <div
          class="thumbnails-box w-full overflow-y-hidden overflow-x-auto text-left"
        >
          <ul
            v-if="data && drawerData && drawerData.length > 0"
            class="thumbnails text-center inline-block my-0 mx-auto h-full whitespace-no-wrap"
          >
            <li
              class="thumbnail bg-white h-full inline-block bg-no-repeat bg-cover bg-center cursor-pointer"
              v-for="item in drawerData"
              :key="item.id"
              :data-target="item.pano_no"
              :data-id="item.id"
              @click.stop="itemChange({ id: item.id, target: item.pano_no })"
            >
              <img
                v-if="item.thumbnail_url"
                class="thumbnail-img"
                :src="item.thumbnail_url"
                alt="缩略图"
              />
              <div class="thumbnail-img" v-else>暂无图片</div>
              <p class="thumbnail-font">
                {{ item.name }}
              </p>
            </li>
          </ul>

          <div v-else class="text-center no-data">
            暂无数据
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'manage-vr',
  props: {
    show: Boolean,
    data: Array,
    active: Object
  },
  data() {
    return {
      drawerData: []
    }
  },
  watch: {
    data() {
      if (!this.data) {
        return
      }
      this.filterData(this.data, this.active)
    },
    active() {
      if (!this.active) {
        return
      }
      this.filterData(this.data, this.active)
    }
  },
  computed: {
    isIphoneX() {
      return (
        /iphone/gi.test(navigator.userAgent) &&
        (screen.height == 812 && screen.width == 375)
      )
    }
  },
  mounted() {
    if (this.data && this.active) {
      this.filterData(this.data, this.active)
    }
    // // eslint-disable-next-line no-console
    // console.log(this.active)
  },
  methods: {
    filterData(data, active) {
      // 对于一级节点的全景图，“附近”显示当前节点前两个一级节点和后两个一级节点的缩略图。
      // 点击缩略图，切换到该缩略图对应的全景页面。
      // “附近”默认为展开状态。点击收起缩略图，点击展开缩略图。
      // 一级节点切换至二级节点时，“附近”显示内容不变。
      // 对于第一个一级节点和最后一个一级节点：第一个一级节点的“附近”显示最后两个一级节点和第二、三个一级节点的缩略图；
      // 最后一个一级节点的“附近”显示倒数第二、三个一级节点和第一、二个一级节点的缩略图

      // let newData = this.data.filter(
      //   item => item.type === 'panorama' && item.visible === 1
      // )
      // newData.forEach((item, index) => {
      //   if (item.pano_no === active.pano_no) {
      //     // eslint-disable-next-line no-console
      //     console.log({ item, index })

      //     if ((item.depth === 1 || item.depth === '1') && index === 0) {
      //     }
      //   }
      // })
      // // eslint-disable-next-line no-console
      // console.log({ data, active })
      let newArr = []
      if (data && active && (active.depth === 1 || active.depth === '1')) {
        let depthOne = JSON.parse(JSON.stringify(this.data)).filter(
          item => item.depth === 1 || item.depth === '1'
        )
        let length = depthOne.length

        JSON.parse(JSON.stringify(depthOne)).forEach((item, index) => {
          // // eslint-disable-next-line no-console
          // console.log({ item, index })
          if (
            active.pano_no &&
            item.pano_no &&
            item.pano_no === active.pano_no
          ) {
            // // eslint-disable-next-line no-console
            // console.log({ item, index })
            // if (index === 0) {
            //   // 第一个一级节点的“附近”显示最后两个一级节点和第二、三个一级节点的缩略图
            //   if (length > 1) {
            //     newArr.push(depthOne[1])
            //   }
            //   if (length > 2) {
            //     newArr.push(depthOne[2])
            //   }
            //   if (length > 4) {
            //     newArr.push(depthOne[length - 2])
            //   }
            //   if (length > 3) {
            //     newArr.push(depthOne[length - 1])
            //   }
            // } else if (index === length - 1) {
            //   // 最后一个一级节点的“附近”显示倒数第二、三个一级节点和第一、二个一级节点的缩略图
            //   if (length > 1) {
            //     newArr.push(depthOne[0])
            //   }
            //   if (length > 2) {
            //     newArr.push(depthOne[1])
            //   }
            //   if (length > 4) {
            //     newArr.push(depthOne[length - 3])
            //   }
            //   if (length > 3) {
            //     newArr.push(depthOne[length - 2])
            //   }
            // } else {
            // 中间一级节点的“附近”显示 前二 后二 节点的缩略图
            let begin = index - 2 < 0 ? 0 : index - 2
            let end = index + 2 > length - 1 ? length - 1 : index + 2
            newArr = depthOne
              .slice(begin, index)
              .concat(depthOne.slice(index + 1, end + 1))
            // }
          }
        })
        sessionStorage.removeItem('drawerData')
        sessionStorage.setItem('drawerData', JSON.stringify(this.drawerData))
      } else {
        newArr = JSON.parse(sessionStorage.getItem('drawerData')) || []
      }

      this.drawerData = []
      this.drawerData = newArr
      // // eslint-disable-next-line no-console
      // console.log(newArr)
    },
    filterImg(item) {
      if (!item.models || item.models.length === 0) {
        return false
      }
      let thisItem = item.models.filter(item => item.type === 'current')
      return thisItem[0].path_url
    },
    itemChange(e) {
      this.$parent.switchScene(e)
    }
  }
}
</script>
<style lang="scss" scoped>
.drawer-enter-active,
.drawer-leave-active {
  transition: all 0.35s ease;
  -moz-transition: all 0.35s ease; /* Firefox 4 */
  -webkit-transition: all 0.35s ease; /* Safari 和 Chrome */
  -o-transition: all 0.35s ease; /* Opera */
}
.drawer-enter, .drawer-leave-to /* .drawer-leave-active below version 2.1.8 */ {
  opacity: 0;
  height: 0;
}

// 轮播图样式
.btn-drawer {
  // width: 6rem;
  width: 100%;
  height: 4rem;
  line-height: 4rem;
  // background-color: pink;
  position: absolute;
  top: -4rem;
  left: 0;
  overflow: hidden;
  vertical-align: top;
  .btn-drawer-font {
    font-size: 1rem;
    color: #fff;
    padding-left: 0.75rem;
    font-weight: 600;
  }
  // 新
  .btns-arrow {
    width: 1.7rem;
    height: 4rem;
    background-size: 1rem 0.6rem;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url('../../public/images/btns/arrow.png');
  }
  &.active {
    .btns-arrow {
      transition: all 0.5s ease;
      -moz-transition: all 0.5s ease; /* Firefox 4 */
      -webkit-transition: all 0.5s ease; /* Safari 和 Chrome */
      -o-transition: all 0.5s ease; /* Opera */
      transform: rotate(180deg);
      -ms-transform: rotate(180deg); /* IE 9 */
      -moz-transform: rotate(180deg); /* Firefox */
      -webkit-transform: rotate(180deg); /* Safari 和 Chrome */
      -o-transform: rotate(180deg); /* Opera */
    }
  }
}
.h75 {
  height: 7.5rem;
}
.thumbnails-box {
  // height: 10.5rem;
  &::-webkit-scrollbar {
    width: 0 !important;
  } /* Safari 和 Chrome */
  -ms-overflow-style: none; /* IE 10+ */
  overflow: -moz-scrollbars-none; /* Firefox */
}
.thumbnails {
  box-sizing: border-box;
  padding: 0.75rem 0.75rem 0 0.75rem;
  padding-right: 0px;
}
.thumbnail {
  vertical-align: top;
  width: 7.5rem;
  margin: 0 1rem 0.75rem 0;
  opacity: 0.8;
  background-color: rgba(0, 0, 0, 0);
  &:hover {
    opacity: 1;
  }
  &.active {
    opacity: 1;
    border: 1px solid red;
  }
}
.thumbnail-img {
  width: 100%;
  height: 7.5rem;
  line-height: 7.5rem;
  vertical-align: top;
  background-color: #fff;
}
.thumbnail-font {
  padding: 0.3rem 0;
  width: 100%;
  color: #fff;
  line-height: 1.5;
  font-weight: 600;
  font-size: 1rem;
  word-wrap: break-word;
  white-space: normal;
}
.iconfont {
  font-size: 1.2rem;
  color: #979797;
  padding: 0.625rem;
  &:hover {
    color: #fff;
  }
}
.bg-tr6 {
  background-color: rgba(0, 0, 0, 0.6);
}
.x-css {
  .thumbnail {
    margin-bottom: 30pt;
  }
}
</style>
